module.exports = __webpack_public_path__ + "plastic-streaming.jpg?57c898cdb6f9110adf0b7f85839dc4b2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plastic-streaming.jpg
// module id = 243
// module chunks = 0